import { Action, RecommendedAction } from '../types/agenticTriageReport';

/**
 * Transforms backend recommended_actions_info to UI Action objects
 * Backend provides actions as strings, we map them to typed Action objects
 */
export const transformRecommendedActions = (
  actions: Array<string | null> | null | undefined,
): Action[] => {
  if (!actions) return [];

  const result: Action[] = [];

  // Define action mappings for string matching
  const actionMappings = [
    {
      match: (a: string) => a.includes('isolate'),
      type: RecommendedAction.IsolateEntity,
    },
    {
      match: (a: string) => a.includes('preserve') || a.includes('evidence'),
      type: RecommendedAction.PreserveEvidence,
    },
    {
      match: (a: string) => a.includes('block'),
      type: RecommendedAction.BlockConnections,
    },
    {
      match: (a: string) => a.includes('suppress'),
      type: RecommendedAction.SuppressEntity,
    },
  ];

  // Map string actions to typed actions
  actions.forEach((action) => {
    if (!action) return;

    const lowerAction = action.toLowerCase();

    const mapping = actionMappings.find((m) => m.match(lowerAction));

    result.push({
      type: mapping ? mapping.type : RecommendedAction.PreserveEvidence,
      description: action,
    });
  });

  return result;
};
